import React from 'react';
import styled, { keyframes } from 'styled-components';
import { withRouter } from 'react-router';
import AllbinBar from 'allbin-bar';
import withStore from 'with-store';
import oh from 'output-helpers';
import * as order_helpers from '../../helpers/order_helpers';
import * as entity_helpers from '../../helpers/entity_helpers';
import * as excel_helpers from '../../helpers/excel_helpers';
import Navbar from '../base/Navbar';
import Button from '../base/Button';
import userInputs from 'user-inputs';
import changelog from '../../changelog';
import ImageCreateWhat from '../../img/create_what.png';
import ImageCreateEntity from '../../img/create_entity.png';
import { MdDirectionsBus, MdMessage, MdTrain } from 'react-icons/md';
import default_config from '../../default_config';
import { FaExclamation } from 'react-icons/all';
import api_helpers from '../../helpers/api_helpers.js';
import xlsx from 'xlsx';
import SimpleDialog from '../base/SimpleDialog';
import AlertDialog from '../base/AlertDialog';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import { TableBody } from '@material-ui/core';
import Table from '@material-ui/core/Table';
import TableContainer from '@material-ui/core/TableContainer';
import { AllbinaryTheme } from '../../themes/allbinary';

const OrderState = {
    PUBLISHED: 'published',
    ASSIGNED: 'assigned',
    COMPLETED: 'completed',
    APPROVED: 'approved',
};

const ViewType = {
    ORDERS: 0,
    ENTITIES: 1,
    EXCEL: 2,
};

class MainView extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            selected_view_type: ViewType.ORDERS, // Orders or vehicles
            selected_category: OrderState.PUBLISHED, // List subcategories (utlagt, pågående, etc)
            search_term_orders: '',
            selected_orders_in_table: [], // checkboxes
            search_term_vehicles: '',
            workbook: [],
            sheet_names: [],
            excel_import: [],
            id: '',
            alert: null,
        };

        this.language = window.sso.getJWT().getClaim('lang');

        const anim_slide_in = keyframes`
            from {
                transform: translateX(-50%);
            }
            to {
                transform: none;
            }
        `;

        this.container = styled.div`
            .dashboard_layout {
                display: grid;
                grid-column-gap: 2%;
                grid-template-columns: 220px calc(98% - 220px);
                padding: 30px;
                height: 90vh;
                .dashboard_ctr {
                    input {
                        margin-bottom: 12px;
                    }
                }
            }
            .MuiTableCell-head {
                background-color: ${p => p.theme.colors.dark[0]};
                color: #fff;
            }
            .MuiTableCell-body {
                background-color: white;
                color: ${p => p.theme.colors.text};
                cursor: pointer;
            }
            .MuiTableRow-root:hover {
                .MuiTableCell-body {
                    background: #dedede !important;
                }
            }

            .excel_ctrl {
                margin: auto;
                width: 50%;
                padding: 50px 0;
                & .excel_ctrl_select_container {
                    width: 100%;
                    display: flex;
                    justify-content: flex-end;
                    margin: 10px 0;
                    & select {
                        flex: 2;
                    }
                    & label {
                        flex: 1;
                    }
                }
                & button {
                    margin: 25px 0;
                }
            }

            .action_button {
                cursor: pointer;
                border: 1px solid ${props => props.theme.colors.red[0]};
                background-color: ${props => props.theme.colors.red[1]};
                padding: 12px 32px;
                color: #fff;
                border-radius: 4px;
                font-size: 14px;
                font-weight: bold;
                transition: all 0.3s;
                &:hover {
                    background-color: ${props => props.theme.colors.red[2]};
                }
            }
            .excel_button {
                margin: 25px;
            }
            .vehicle_icon {
                width: 30px;
                padding: 0px 14px !important;
                vertical-align: middle;
                .box {
                    width: 25px;
                    height: 25px;
                    border-radius: 12px;
                    background-color: ${props => props.theme.colors.blue[2]};
                    &.train {
                        background-color: #f3c006;
                    }
                    &.no_vehicle_number {
                        background-color: #f48a78;
                    }
                    svg {
                        fill: #fff;
                        margin: 3.5px;
                        width: 20px;
                        height: 20px;
                    }
                }
            }
            .order_icons {
                .svg.new_message {
                    width: 24px;
                    height: 24px;
                    vertical-align: middle;
                    display: none;
                    fill: ${props => props.theme.colors.red[1]};
                }
            }
            .view_switch {
                position: absolute;
                top: 16px;
                left: 50%;
                transform: translateX(-50%);
                border-radius: 40px;
                color: #fff;
                background-color: rgba(0, 0, 0, 0.3);
                text-shadow: 0 3px 5px rgba(0, 0, 0, 0.25);
                .view_switch_bg {
                    border-radius: 40px;
                    width: 55%;
                    margin-top: -4px;
                    margin-left: -4px;
                    height: calc(100% + 8px);
                    position: absolute;
                    top: 0;
                    z-index: 1;
                    transition: background-color 1s, left 0.4s;
                    &.state_0 {
                        left: 0;
                        background-color: ${props => props.theme.colors.red[1]};
                    }
                    &.state_1 {
                        left: 50%;
                        background-color: ${props =>
                            props.theme.colors.blue[1]};
                    }
                }
                p {
                    position: relative;
                    z-index: 2;
                    cursor: pointer;
                    display: inline-block;
                    padding: 8px 16px;
                    opacity: 0.5;
                    font-weight: bold;
                    &:hover {
                        opacity: 1;
                    }
                    &.active {
                        opacity: 1;
                    }
                }
            }
            .dashboard_multi_edit_box,
            .dashboard_ctr .user_input {
                animation: ${anim_slide_in} 0.5s both;
            }
            .empty {
                text-align: center;
                margin-right: 15%;
                .empty_image {
                    margin: 20px auto;
                    background-repeat: no-repeat;
                    background-position: center;
                    height: 200px;
                    width: 200px;
                    background-size: contain;
                    &.orders {
                        background-image: url(${ImageCreateWhat});
                    }
                    &.entities {
                        background-image: url(${ImageCreateEntity});
                    }
                }
                .empty_label {
                    p {
                        color: #48558c;
                        font-size: 18px;
                        line-height: 22px;
                        font-weight: bold;
                        margin-bottom: 4px;
                    }
                    span {
                        color: #7782b4;
                        font-size: 14px;
                        line-height: 22px;
                    }
                }
            }
        `;

        this.state_label = styled.div`
            font-size: 12px;
            padding: 4px 12px;
            border-radius: 20px;
            color: #fff;
            display: inline-block;
            background-color: ${props =>
                props.theme.colors.states[props.state]
                    ? props.theme.colors.states[props.state]
                    : 'gray'};
        `;

        this.order_filters = userInputs.generateForm([
            {
                onChange: e => {
                    this.setState({ search_term_orders: e });
                },
                value: this.state.search_term_orders,
                key: 'search',
                type: 'text',
                label: oh.translate('search'),
                default_value: '',
            },
        ]);
        this.vehicles_filters = userInputs.generateForm([
            {
                onChange: e => {
                    this.setState({ search_term_vehicles: e });
                },
                value: this.state.search_term_vehicles,
                key: 'search',
                type: 'text',
                label: oh.translate('search'),
                default_value: '',
            },
        ]);

        this.order_state_categories = [
            {
                name: 'published',
                onClick: () => {
                    this.setState({
                        selected_category: OrderState.PUBLISHED,
                    });
                },
            },
            {
                name: 'assigned',
                onClick: () => {
                    this.setState({
                        selected_category: OrderState.ASSIGNED,
                    });
                },
            },
            {
                name: 'completed',
                onClick: () => {
                    this.setState({
                        selected_category: OrderState.COMPLETED,
                    });
                },
            },
            {
                name: 'approved',
                onClick: () => {
                    this.setState({
                        selected_category: OrderState.APPROVED,
                    });
                    order_helpers.fetchApproved();
                },
            },
        ];
    }

    getPriority(priority) {
        const color = default_config.star_color[priority - 1];
        return <FaExclamation fill={color} />;
    }

    getIcon(vehicle) {
        let styleClass = 'box';
        let icon = <MdDirectionsBus />;

        if (
            vehicle.data['meta.vehicle_type'] &&
            vehicle.data['meta.vehicle_type'] === 'Tåg'
        ) {
            icon = <MdTrain />;
            styleClass += ' train';
        }

        if (vehicle.data['meta.vehicle_number'] === null) {
            styleClass += ' no_vehicle_number';
        }

        return <div className={styleClass}>{icon}</div>;
    }
    handleExcel() {
        const file = this.fileSelector.files[0];
        let type = '';

        file.type.length > 0
            ? (type = file.type)
            : (type = file.name.slice(
                  Math.max(0, file.name.lastIndexOf('.')) + 1,
              ));

        if (
            type ===
                'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' ||
            type === 'xlsx' ||
            type === 'xls'
        ) {
            excel_helpers.pFilerreader(file).then(e => {
                const data = new Uint8Array(e.target.result);
                const workbook = xlsx.read(data, { type: 'array' });
                this.setState({
                    sheet_names: workbook.SheetNames,
                    workbook: workbook,
                });
            });
        } else {
            alert(oh.translate('file_is_of_wrong_type'));
        }
    }
    renderContent(selected_category) {
        if (this.state.selected_view_type === ViewType.ORDERS) {
            return this.renderOrderView(selected_category);
        }

        let vehicles = this.props.se.getVehicles();

        let schema = this.props.store.entity.schema.vehicles;

        this.fileSelector = buildFileSelector();
        this.fileSelector.onchange = this.handleExcel.bind(this);

        if (this.state.selected_view_type === ViewType.ENTITIES) {
            return this.renderEntityView(schema, vehicles);
        }

        if (this.state.selected_view_type === ViewType.EXCEL) {
            return this.renderExcelView(schema, vehicles);
        }
    }
    renderEntityView(schema, vehicles) {
        if (this.state.search_term_vehicles.length > 0) {
            const splitSearch = this.state.search_term_vehicles
                .toLowerCase()
                .split(' ');
            vehicles = vehicles.filter(x =>
                splitSearch.every(s => x.match_str.toLowerCase().includes(s)),
            );
        }
        const table_columns = [''];
        schema.properties
            .filter(prop => prop.key !== 'meta.photos')
            .forEach(prop => {
                if (prop.key.startsWith('meta.')) {
                    table_columns.push(
                        schema.translations[this.language][prop.key],
                    );
                } else {
                    table_columns.push(prop.name);
                }
            });
        return (
            <div className="content_container">
                <Navbar border />
                <div className="dashboard_layout">
                    <div className="dashboard_ctr">
                        <this.vehicles_filters.component />
                        <small>{oh.translate('separate_search')}</small>
                        <button
                            className="action_button excel_button"
                            onClick={() => this.fileSelector.click()}
                        >
                            {oh.translate('import_excel')}
                        </button>
                    </div>
                    <TableContainer className="table_container">
                        <Table stickyHeader>
                            <TableHead>
                                <TableRow>
                                    {table_columns.map((item, i) => (
                                        <TableCell key={i + 1}>
                                            {item}
                                        </TableCell>
                                    ))}
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {vehicles.map((vehicle, i) =>
                                    this.createVehicleRow(vehicle, i, schema),
                                )}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </div>
            </div>
        );
    }
    createVehicleRow = (vehicle, i, schema) => {
        let table_row_values = schema.properties
            .filter(prop => prop.key !== 'meta.photos')
            .map(prop => {
                if (vehicle.data.hasOwnProperty(prop.key) === false) {
                    return '-';
                }
                let prop_value = vehicle.data[prop.key];
                if (prop_value === null) {
                    return '-';
                }

                if (prop.type === 'boolean') {
                    if (prop_value) {
                        return oh.translate('yes');
                    }
                    return oh.translate('no');
                } else if (prop.type === 'entity') {
                    return entity_helpers.getIdFromRef(prop_value);
                }
                return prop_value;
            });
        return (
            <TableRow
                key={i}
                onClick={() => this.props.se.setSelectedEntity(vehicle.id)}
            >
                <TableCell className={'vehicle_icon'}>
                    {this.getIcon(vehicle)}
                </TableCell>
                {table_row_values.map((item, i) => {
                    return <TableCell key={i}>{item}</TableCell>;
                })}
            </TableRow>
        );
    };
    renderOrderView(selected_category) {
        const action_button = {
            label: oh.translate('place_new_order'),
            onClick: () => {
                this.props.history.push('/create');
            },
        };

        let orders = this.props.se.getOrders();
        orders.sort((a, b) => {
            return b.last_modified - a.last_modified;
        });

        const filtered_orders_by_category = Object.values(OrderState).reduce(
            (order_by_category, category) => {
                order_by_category[category] = orders
                    .filter(order => order.state === category)
                    .sort((a, b) => {
                        const a_prio = a.data.priority ? a.data.priority : 0;
                        const b_prio = b.data.priority ? b.data.priority : 0;
                        if (a_prio > b_prio) {
                            return -1;
                        }
                        if (a_prio < b_prio) {
                            return 1;
                        }
                        return 0;
                    });
                return order_by_category;
            },
            {},
        );
        if (this.state.search_term_orders.length > 0) {
            filtered_orders_by_category[
                selected_category
            ] = filtered_orders_by_category[selected_category].filter(order => {
                const vehicles = this.props.se.getVehicles();
                const order_vehicles = vehicles.filter(v => (order.entities || []).includes(v.id));

                const vehicle_match_str = order_vehicles.map(v => (v.id.toLowerCase() + ':' + v.data['meta.vehicle_number'])).join(',');
                return order.match_str
                    .toLowerCase()
                    .includes(this.state.search_term_orders.toLowerCase()) || vehicle_match_str.includes(this.state.search_term_orders.toLowerCase());

            });
        }
        const categories_with_message_count = this.order_state_categories.map(
            category => ({
                ...category,
                messages_count: filtered_orders_by_category[
                    category.name
                ].reduce((message_count, order) => {
                    let messages_last_viewed = this.props.se.getLastViewed(
                        order.id,
                        'order_messages',
                    );
                    if (
                        (order.data.hasOwnProperty('last_message_posted_at') &&
                            order.data.last_message_posted_at >
                                messages_last_viewed) ||
                        (messages_last_viewed === null &&
                            order.data.last_message_posted_at !== undefined)
                    ) {
                        message_count += 1;
                    }
                    return message_count;
                }, 0),
            }),
        );
        return (
            <div className="content_container orders">
                <Navbar
                    border
                    categories_with_message_count={
                        categories_with_message_count
                    }
                    selected_category={Object.values(OrderState).findIndex(
                        category => category === this.state.selected_category,
                    )}
                    action_button={action_button}
                />
                <div className="dashboard_layout t">
                    <div className="dashboard_ctr">
                        {this.state.selected_orders_in_table.length < 1 ? (
                            <this.order_filters.component />
                        ) : (
                            <div className="dashboard_multi_edit_box">
                                <Button
                                    filled
                                    block
                                    red
                                    label={oh.translate('remove')}
                                    onClick={() => {
                                        this.props.userPrompt.alert({
                                            props: {
                                                title: oh.translate(
                                                    'not_implemented',
                                                ),
                                                message: oh.translate(
                                                    'not_implemented_in_test_version',
                                                ),
                                                confirm_button_label: oh.translate(
                                                    'ok',
                                                ),
                                            },
                                        });
                                    }}
                                />
                            </div>
                        )}
                    </div>
                    <TableContainer className="dashboard_presentation">
                        {filtered_orders_by_category[selected_category] &&
                        filtered_orders_by_category[selected_category].length >
                            0 ? (
                            <Table stickyHeader>
                                <TableHead>
                                    <TableRow>
                                        <TableCell>
                                            {oh.translate('id')}
                                        </TableCell>
                                        <TableCell>
                                            {oh.translate('vehicle')}
                                        </TableCell>
                                        <TableCell>
                                            {oh.translate('address')}
                                        </TableCell>
                                        {selected_category !==
                                            OrderState.PUBLISHED &&
                                        selected_category !==
                                            OrderState.ASSIGNED ? (
                                            <TableCell>
                                                {oh.translate('invoice_info')}
                                            </TableCell>
                                        ) : selected_category ===
                                          OrderState.ASSIGNED ? (
                                            <TableCell>
                                                {oh.translate(
                                                    'associated_users',
                                                )}
                                            </TableCell>
                                        ) : (
                                            <TableCell>
                                                {oh.translate('created_by')}
                                            </TableCell>
                                        )}
                                        <TableCell>
                                            {oh.translate('state')}
                                        </TableCell>
                                        <TableCell>
                                            {oh.translate('last_edit')}
                                        </TableCell>
                                        <TableCell>
                                            {oh.translate('priority')}
                                        </TableCell>
                                        <TableCell className="order_icons"></TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {filtered_orders_by_category[
                                        selected_category
                                    ].map((order, i) => {
                                        let messages_last_viewed = this.props.se.getLastViewed(
                                            order.id,
                                            'order_messages',
                                        );
                                        let registration = '';
                                        if (order.entities) {
                                            registration = order.entities.reduce(
                                                (acc, entity) => {
                                                    acc +=
                                                        decodeURI(
                                                            entity
                                                                .split('/')
                                                                .pop(),
                                                        ).replace(/\s/g, '') +
                                                        ' ';
                                                    return acc;
                                                },
                                                '',
                                            );
                                            if (order.entities.length > 2) {
                                                registration =
                                                    order.entities
                                                        .slice(0, 2)
                                                        .reduce(
                                                            (acc, entity) => {
                                                                acc +=
                                                                    decodeURI(
                                                                        entity
                                                                            .split(
                                                                                '/',
                                                                            )
                                                                            .pop(),
                                                                    ).replace(
                                                                        /\s/g,
                                                                        '',
                                                                    ) + ' ';
                                                                return acc;
                                                            },
                                                            '',
                                                        )
                                                        .trim() + '...';
                                            }
                                        }
                                        const resolved_order = order_helpers.resolve(
                                            order,
                                        );
                                        const associated_users = resolved_order.getAssociatedUsers();
                                        let first_associated_user_full_name =
                                            '';
                                        if (associated_users.length > 0) {
                                            first_associated_user_full_name =
                                                associated_users[0].full_name;
                                        }
                                        return (
                                            <TableRow
                                                key={i}
                                                onClick={e => {
                                                    this.props.se.setSelectedOrder(
                                                        order.id,
                                                    );
                                                }}
                                            >
                                                <TableCell>
                                                    {order.id}
                                                </TableCell>
                                                <TableCell>
                                                    {registration}
                                                </TableCell>
                                                <TableCell>
                                                    {order.data.address}
                                                </TableCell>
                                                {selected_category !==
                                                    OrderState.ASSIGNED &&
                                                selected_category !==
                                                    OrderState.PUBLISHED ? (
                                                    <TableCell>
                                                        {order.data.invoice_info
                                                            ? order.data
                                                                  .invoice_info
                                                            : ''}
                                                    </TableCell>
                                                ) : selected_category !==
                                                  OrderState.PUBLISHED ? (
                                                    <TableCell>
                                                        {
                                                            first_associated_user_full_name
                                                        }
                                                    </TableCell>
                                                ) : (
                                                    <TableCell>
                                                        {
                                                            order.creator
                                                                .full_name
                                                        }
                                                    </TableCell>
                                                )}
                                                <TableCell>
                                                    <this.state_label
                                                        state={order.state}
                                                    >
                                                        {oh.translate(
                                                            'singular_' +
                                                                order.state,
                                                        )}
                                                    </this.state_label>
                                                </TableCell>
                                                <TableCell>
                                                    {oh.formatDateAsString(
                                                        order.last_modified,
                                                        'YYYY-MM-DD HH:mm:ss',
                                                    )}
                                                </TableCell>
                                                <TableCell>
                                                    {order.data.priority &&
                                                        this.getPriority(
                                                            order.data.priority,
                                                        )}
                                                </TableCell>
                                                <TableCell className="order_icons">
                                                    {/*<MdPriorityHigh className="updated" />*/}
                                                    {((order.data.hasOwnProperty(
                                                        'last_message_posted_at',
                                                    ) &&
                                                        order.data
                                                            .last_message_posted_at >
                                                            messages_last_viewed) ||
                                                        (messages_last_viewed ===
                                                            null &&
                                                            order.data
                                                                .last_message_posted_at !==
                                                                undefined)) && (
                                                        <MdMessage
                                                            className="new_message"
                                                            fill={
                                                                AllbinaryTheme
                                                                    .colors
                                                                    .red[1]
                                                            }
                                                        />
                                                    )}
                                                </TableCell>
                                            </TableRow>
                                        );
                                    })}
                                </TableBody>
                            </Table>
                        ) : (
                            <div className="empty">
                                <div className={`empty_image orders`}> </div>
                                <div className="empty_label">
                                    <p>{oh.translate('no_orders')}</p>
                                    <span>
                                        {oh.translate('no_orders_in_state')}:{' '}
                                        <b>
                                            {oh.translate(
                                                this.state.selected_category,
                                            )}
                                        </b>
                                    </span>
                                </div>
                            </div>
                        )}
                    </TableContainer>
                </div>
            </div>
        );
    }
    renderExcelView(schema, vehicles) {
        const schema_properties = schema.properties.filter(
            prop => prop.key !== 'meta.photos',
        );
        return (
            <div className="content_container">
                <Navbar border />
                <div className={'excel_ctrl'}>
                    {schema_properties.map(schema_property => {
                        let name = schema_property.name;
                        if (schema_property.key.startsWith('meta.')) {
                            name =
                                schema.translations[this.language][
                                    schema_property.key
                                ];
                        }
                        return (
                            <div
                                className="excel_ctrl_select_container"
                                key={schema_property.key}
                            >
                                <label>{name}</label>
                                <select id={schema_property.key}>
                                    <option value={'Exclude'}>
                                        {oh.translate('exclude')}
                                    </option>
                                    {Object.keys(
                                        this.state.excel_import[0],
                                    ).map(selected_value => (
                                        <option
                                            value={`${schema_property.key}|${selected_value}|${schema_property.alternatives}|${schema_property.type}`}
                                            key={selected_value}
                                        >
                                            {selected_value}
                                        </option>
                                    ))}
                                </select>
                            </div>
                        );
                    })}
                    <Button
                        filled
                        dark
                        block
                        label={oh.translate('save')}
                        onClick={() => {
                            const selected = schema_properties.map(prop => {
                                const e = document.getElementById(
                                    String(prop.key),
                                );
                                return e.options[e.selectedIndex].value;
                            });
                            let id;
                            const selected_property_mapping = selected.reduce(
                                (acc, current) => {
                                    const split = current.split('|');
                                    const schema_property = split[0];
                                    const selected_value = split[1];
                                    const alt = split[2];
                                    const type = split[3];
                                    if (current !== 'Exclude') {
                                        acc[selected_value] = {
                                            value: schema_property,
                                            accepted: alt,
                                            type: type,
                                        };
                                    }
                                    if (schema_property === 'meta.id') {
                                        id = selected_value;
                                    }
                                    return acc;
                                },
                                {},
                            );
                            if (id) {
                                this.onSaveExcel(
                                    schema_properties,
                                    selected_property_mapping,
                                    vehicles,
                                    id,
                                );
                            } else {
                                alert(oh.translate('id_needs_to_be_selected'));
                            }
                        }}
                    />
                </div>
            </div>
        );
    }
    onSaveExcel(schema_properties, selected_property_mapping, vehicles, id) {
        let faulty_rows = [];

        //Get every row (vehicle) in excelsheet
        this.state.excel_import.forEach(value => {
            let matching_prop_types = true;
            const found = vehicles.find(
                vehicle => vehicle.data['meta.id'] === value[id],
            );
            const data = {};
            //Check every prop on vehicle in row
            const faulty = {
                id: value[id],
                props: [],
            };
            Object.keys(value).forEach(key => {
                const selected_prop = selected_property_mapping[key];
                if (selected_prop) {
                    if (value[key] === 'X') {
                        value[key] = true;
                    }
                    if (selected_prop.accepted !== 'undefined') {
                        if (
                            !selected_prop.accepted
                                .split(',')
                                .includes(value[key])
                        ) {
                            matching_prop_types = false;
                            faulty.props.push(
                                '"' +
                                    key.replace(/[\n\r]/g, ' ') +
                                    '" : "' +
                                    value[key] +
                                    '"',
                            );
                        }
                    } else if (
                        selected_prop.type !== 'undefined' &&
                        selected_prop.type !== 'entity'
                    ) {
                        if (!(typeof value[key] === selected_prop.type)) {
                            matching_prop_types = false;
                            faulty.props.push(
                                '"' +
                                    key.replace(/[\n\r]/g, ' ') +
                                    '" : "' +
                                    value[key] +
                                    '"',
                            );
                        }
                    }
                    if (matching_prop_types) {
                        data['meta.id'] = value[id]
                            .toUpperCase()
                            .replace(/[^A-Za-z0-9\s!?]/g, '');
                        const property = schema_properties.find(
                            prop => selected_prop.value === prop.key,
                        );
                        if (property.type === 'entity') {
                            data[selected_prop.value] = encodeURI(
                                'entity://' + value[key],
                            );
                        } else {
                            data[selected_prop.value] = value[key];
                        }
                    }
                }
            });
            if (matching_prop_types) {
                if (found) {
                    found.data = {
                        ...found.data,
                        ...data,
                    };
                    api_helpers
                        .updateEntity('vehicles', found)
                        .then(vehicle_entity => {
                            this.props.actions.entity.setEntity(
                                'vehicle',
                                vehicle_entity,
                            );
                        });
                } else {
                    api_helpers
                        .createEntity('vehicles', {
                            id: value[id]
                                .toUpperCase()
                                .replace(/[^A-Za-z0-9\s!?]/g, ''),
                            data: data,
                        })
                        .then(vehicle_entity => {
                            this.props.actions.entity.setEntity(
                                'vehicle',
                                vehicle_entity,
                            );
                        });
                }
            } else {
                if (faulty.props.length > 0) {
                    faulty_rows.push(faulty);
                }
            }
        });
        if (faulty_rows.length > 0) {
            let message = '';
            faulty_rows.forEach(faulty => {
                message +=
                    'Fordon ' +
                    faulty.id +
                    ' har felaktigt värde för ' +
                    faulty.props.join(', ') +
                    '\n';
            });
            this.setState({
                alert: {
                    title: oh.translate('some_not_matching_schema'),
                    content: message,
                },
            });
        }
        this.setState({
            selected_view_type: ViewType.ENTITIES,
        });
    }
    render() {
        return (
            <this.container>
                <div className="">
                    <AllbinBar
                        language={this.language}
                        background={'#2B344D'}
                        navbar={true}
                        styled_service_name={true}
                        logout={true}
                        service_name={'Installation'}
                        enable_password_reset={false}
                        dashboard_link={true}
                        contact={true}
                        changelog={changelog}
                        help={false}
                        show_credentials={true}
                    />
                </div>
                <div className="view_switch">
                    <div
                        className={`view_switch_bg state_${this.state.selected_view_type}`}
                    />
                    <p
                        className={`${
                            this.state.selected_view_type === ViewType.ORDERS
                                ? 'active'
                                : ''
                        }`}
                        onClick={() => {
                            this.setState({
                                selected_view_type: ViewType.ORDERS,
                                selected_category: OrderState.ASSIGNED,
                                search_term_vehicles: '',
                                search_term_orders: '',
                            });
                        }}
                    >
                        {oh.translate('orders')}
                    </p>
                    <p
                        className={`${
                            this.state.selected_view_type === ViewType.ENTITIES
                                ? 'active'
                                : ''
                        }`}
                        onClick={() => {
                            this.setState({
                                selected_view_type: ViewType.ENTITIES,
                                selected_category: OrderState.ASSIGNED,
                                search_term_vehicles: '',
                                search_term_orders: '',
                            });
                        }}
                    >
                        {oh.translate('vehicles')}
                    </p>
                </div>
                <SimpleDialog
                    values={this.state.sheet_names}
                    title={oh.translate('select_sheet')}
                    open={this.state.sheet_names.length > 0}
                    onClose={sheet_name => {
                        const selected = xlsx.utils.sheet_to_json(
                            this.state.workbook.Sheets[sheet_name],
                        );
                        this.setState({
                            selected_view_type: sheet_name
                                ? ViewType.EXCEL
                                : ViewType.ENTITIES,
                            sheet_names: [],
                            excel_import: selected,
                        });
                    }}
                />
                {this.state.alert && (
                    <AlertDialog
                        open={true}
                        onClose={function() {
                            this.setState({ alert: null });
                        }.bind(this)}
                        content={this.state.alert.content}
                        title={this.state.alert.title}
                    />
                )}
                {this.renderContent(this.state.selected_category)}
            </this.container>
        );
    }
}

function buildFileSelector() {
    const fileSelector = document.createElement('input');
    fileSelector.id = 'file_input';
    fileSelector.setAttribute('type', 'file');
    return fileSelector;
}

export default withRouter(withStore(userInputs(MainView)));



// WEBPACK FOOTER //
// ./src/components/views/MainView.jsx